import { monthName } from 'Utils/helpers/dateUtils'

export enum PolicyPeriodDuration {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  Yearly = 'yearly',
  OneTime = 'one_time'
}

export const PolicyPeriodDurationDisplay: Map<PolicyPeriodDuration, string> = new Map([
  [PolicyPeriodDuration.Monthly, 'month'],
  [PolicyPeriodDuration.Quarterly, 'quarter'],
  [PolicyPeriodDuration.Yearly, 'year'],
  [PolicyPeriodDuration.OneTime, 'one-time']
])

export enum RolloverOptions {
  Disabled = 'disabled',
  Indefinite = 'indefinite',
  EndOfYear = 'end_of_year'
}

export const PolicyPeriodDurationLabel: Map<PolicyPeriodDuration, string> = new Map([
  [PolicyPeriodDuration.Monthly, 'Monthly'],
  [PolicyPeriodDuration.Quarterly, 'Quarterly'],
  [PolicyPeriodDuration.Yearly, 'Annual'],
  [PolicyPeriodDuration.OneTime, 'One-Time']
])

export type BenefitProgramPolicy = {
  id: string
  policyPeriodDuration: PolicyPeriodDuration
  annualResetMonth: number
  eligibilityDurationDays?: number | null
  expenditureAllowance: number
  rollover: RolloverOptions
  ongoingPurchases: boolean
  ongoingPurchaseThreshold?: number
  scheduledStartDate: Date
  scheduledEndDate?: Date
}

export const policyPeriodSummary = (policy: BenefitProgramPolicy): string => {
  const base = PolicyPeriodDurationDisplay.get(policy.policyPeriodDuration) ?? ''

  if (policy.policyPeriodDuration === PolicyPeriodDuration.OneTime) {
    return policy.eligibilityDurationDays ? `${base}, ${policy.eligibilityDurationDays} days` : base
  }

  if (
    policy.policyPeriodDuration === PolicyPeriodDuration.Yearly &&
    policy.annualResetMonth !== 1
  ) {
    return `${base}, resets ${monthName(policy.annualResetMonth)}`
  }

  return base
}

export type UserProgramMembership = BenefitProgramPolicy & {
  policyPeriodDuration: PolicyPeriodDuration
  expenditureAllowance: number
  rollover: string
  ongoingPurchases: boolean
  ongoingPurchaseThreshold: number
  scheduledStartDate: Date
  scheduledEndDate?: Date
}

export const hasRollover = (policy: BenefitProgramPolicy) =>
  policy.rollover !== RolloverOptions.Disabled
